<!--

  @copyright Copyright (c) Open-Xchange GmbH, Germany <info@open-xchange.com>
  @license AGPL-3.0

  This code is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with OX App Suite. If not, see <https://www.gnu.org/licenses/agpl-3.0.txt>.

  Any use of the work other than as authorized under this license or copyright law is prohibited.

-->

<template>
  <li class="category-browser-task-item" aria-hidden="true" data-detail-popup="task" :data-cid="data.cid">
    <div class="icon-container">
      <BaseIcon icon-name="bi/chevron-double-down.svg" className="priority-low" v-if="data.priority === 1"/>
      <BaseIcon icon-name="bi/pause.svg" className="priority-med rotate-90" v-if="data.priority === 2"/>
      <BaseIcon icon-name="bi/chevron-double-up.svg" className="priority-high" v-if="data.priority === 3"/>
      <BaseIcon icon-name="bi/people.svg" className="participants" v-if="data.participants.length > 0"/>
    </div>
    <div class="info-container">
      <div class="flex-row list-item-row">
        <div class="title flex-grow" aria-hidden="true" :title="parsedData.title">{{ parsedData.title }}</div>
      </div>
      <div class="flex-row list-item-row">
        <span v-if="data.end_time" class="time ellipsis flex-grow text-gray" aria-hidden="true" :title="dueDateLabel">{{ dueDateLabel }}</span>
        <span v-else-if="data.note" class="note ellipsis flex-grow text-gray" aria-hidden="true" :title="parsedData.note">{{ parsedData.note}}</span>
        <span :class="badge" aria-hidden="true">{{ parsedData.status || '\u00A0' }}</span>
      </div>
      <BadgeList :limit="3" :collection="categories"/>
    </div>
  </li>
</template>

<script setup>
import { interpretTask } from '@/io.ox/tasks/util'
import BadgeList from '@/io.ox/core/categories/browser/badge-list.vue'
import BaseIcon from '@/io.ox/vueComponents/base-icon.vue'
import gt from 'gettext'

const { data } = defineProps(['data'])
const categories = (data.categories || '').split(',')

const parsedData = interpretTask(data)
const badge = `status ${parsedData.badge}`
// #. %1$s is  the due date of a task
const dueDateLabel = gt('Due Date | %1$s', parsedData.end_time)

</script>

<style>
.category-browser-task-item {
  cursor: pointer;
  padding: 8px 16px 8px 0;
  display: flex;
  height: 72px;

  .categories-badges .category-view {
    line-height: 18px;
    margin-top: 4px;
    height: 18px;
    border-radius: 6px;
    padding-inline: 4px;
  }

  .icon-container {
    padding: 0 4px 0 4px;
    display: flex;
    flex-flow: column;
    width: 32px;
    flex-grow: 0;
    flex-shrink: 0;

    svg {
      height: 20px;
      width: 20px;
      padding: 2px 0;
    }
    .priority-low { color: var(--indigo-600); }
    .priority-med {
      padding: 0px;
      color: var(--yellow-600);
    }
    .priority-high { color: var(--red-600); }
    .participants { padding: 4px }
  }

  .info-container {
    width: calc(100% - 32px);
    .title { font-weight: bold; }
    .status { border-radius: 4px; }
  }

  .list-item-row {
    height: 16px;
    gap: 4px;
    justify-content: flex-end;
  }
  &:focus {
    .time,.note, .icon-container svg { color: var(--selected-focus); }
  }
}
</style>
